/**
 * Stable colour per harness id.
 *
 * A real-world harness often fans out — one DB25 trunk going to a relay,
 * an Ethernet adapter, and a motor connector all in the same physical
 * loom. In the block diagram we represent that as multiple block-to-block
 * edges sharing the SAME `harnessId`. Without a visual cue the user can't
 * tell which block-edges belong together.
 *
 * This helper hashes the harness id into a small curated palette so every
 * block-edge of the same harness paints the same colour on the canvas.
 * Stable across reloads (deterministic hash) and stable across themes
 * (the colours have enough contrast for both light and dark canvases).
 */

const HARNESS_PALETTE = [
  '#dc2626', // red
  '#ea580c', // orange
  '#d97706', // amber
  '#65a30d', // lime
  '#16a34a', // green
  '#0891b2', // cyan
  '#0284c7', // sky
  '#2563eb', // blue
  '#7c3aed', // violet
  '#c026d3', // fuchsia
  '#db2777', // pink
  '#e11d48', // rose
];

export function harnessColor(harnessId: string): string {
  if (!harnessId) return '#64748b';
  let hash = 0;
  for (let i = 0; i < harnessId.length; i += 1) {
    hash = ((hash << 5) - hash + harnessId.charCodeAt(i)) | 0;
  }
  return HARNESS_PALETTE[Math.abs(hash) % HARNESS_PALETTE.length];
}
